import { DialogType } from '../enum/app.enums';

import Swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { FirstUpperCase } from './data-helper';

/*  TODO: update sweetalert to latest version
    https://github.com/sweetalert2/ngx-sweetalert2#swalcomponent
    npm install sweetalert2 @sweetalert2/ngx-sweetalert2

    https://sweetalert2.github.io/#themes
    npm install @sweetalert2/theme-dark
    optional - npm install @sweetalert2/theme-borderless
    // your-app.js
    import Swal from 'sweetalert2/src/sweetalert2.js'

    // your-app.scss
    @import '~@sweetalert2/themes/dark/dark.scss';

    https://sweetalert2.github.io/recipe-gallery/
*/

export function confirmDialogConfig(
    title: string,
    question: string,
    dialogType: DialogType = DialogType.Question,
    subTitle = '',
    htmlMessage = '',
): SweetAlertOptions {
    const header = title !== undefined && title !== null ? title : '';
    const headerMessage = subTitle !== '' && subTitle !== null ? `<p class="m-b-0">${subTitle}</p>` : '';
    const message = htmlMessage !== '' && htmlMessage !== null ? `<div class="dialog-message">${htmlMessage}</div>` : '';
    return {
        title: header,
        html: `${headerMessage}${message}<p class="pt-2">${question}</p>`,
        icon: dialogType,
        showCloseButton: true,
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-secondary',
        },
    };
}

export function commonDialogConfig(
    title: string,
    question: string,
    dialogType: DialogType = DialogType.Question,
    subTitle = '',
    htmlMessage = '',
): SweetAlertOptions {
    const header = title !== undefined && title !== null ? title : '';
    const headerMessage = subTitle !== '' && subTitle !== null ? `<p class="m-b-0">${subTitle}</p>` : '';
    const message = htmlMessage !== '' && htmlMessage !== null ? `<div class="dialog-message">${htmlMessage}</div>` : '';
    return {
        title: header,
        html: `${headerMessage}${message}<p class="pt-2">${question}</p>`,
        icon: dialogType,
        showCloseButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'Ok',
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-secondary',
        },
    };
}

export function resultDialog(dialogType: DialogType, message: string, title = '', htmlMessage = ''): void {
    const header = title !== '' && title !== null ? title : FirstUpperCase(dialogType);
    const headerMessage = message !== '' && message !== null ? `<p class="m-b-0">${message}</p>` : '';
    const bodyMessage = htmlMessage !== '' && htmlMessage !== null ? `<div class="dialog-message">${htmlMessage}</div>` : '';
    (async () =>
        await Swal.fire({
            titleText: header,
            icon: dialogType,
            html: `${headerMessage}${bodyMessage}`,
            allowEscapeKey: false,
            allowOutsideClick: false,
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-secondary',
            },
        }))();
}

export async function showLoading(): Promise<void> {
    await Swal.fire({
        titleText: 'Please Wait',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
            Swal.showLoading();
        },

        // timer: 3000,
        // timerProgressBar: true
    });
}

export async function hideLoading(): Promise<void> {
    await Swal.close();
}

export function hideLoadingAsync(): Promise<void> {
    return new Promise((resolve, reject) => {
        Swal.close();
        setTimeout(() => {
            resolve();
        }, 200);
    });
}

export function errorHandler(err: any, message: string, logger: any, showmessage = true): void {
    let errorMsg = '';
    if (err.error instanceof ErrorEvent) {
        //console.log('this is client side error');
        errorMsg = `App Error`; //: ${err.error.message}`;
    } else {
        //console.log('this is server side error');
        errorMsg = `Server Error`; // Code: ${err.status},  Message: ${err.message}`;
    }
    logger.error(errorMsg);

    if (showmessage) {
        resultDialog(DialogType.Error, message, 'Error', errorMsg);
    }
}

//PROMISE
export const successDialogAsync = async (htmlMessage = ''): Promise<SweetAlertResult> => {
    const alert = await Swal.fire({
        titleText: 'Success',
        icon: DialogType.Success,
        html: htmlMessage,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: false,
    });
    return alert;
};

export const resultDialogAsync = async (dialogType: DialogType, message: string, title = '', htmlMessage = ''): Promise<SweetAlertResult> => {
    const header = title !== '' && title !== null ? title : FirstUpperCase(dialogType);
    const headerMessage = message !== '' && message !== null ? `<p class="m-b-0">${message}</p>` : '';
    const bodyMessage = htmlMessage !== '' && htmlMessage !== null ? `<div class="dialog-message">${htmlMessage}</div>` : '';
    const alert = await Swal.fire({
        titleText: header,
        icon: dialogType,
        html: `${headerMessage}${bodyMessage}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: true,
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-secondary',
        },
    });
    return alert;
};

export const errorHandlerAsync = async (err: any, message: string, logger: any, showmessage = true, htmlMessage = ''): Promise<SweetAlertResult> => {
    let errorMsg = '';
    if (err.error instanceof ErrorEvent) {
        //console.log('this is client side error');
        errorMsg =
            htmlMessage != '' ? `App Error:<div>${err.error.message}</div> <div>${htmlMessage}</div>` : `App Error:<div>${err.error.message}</div>`;
        logger.error('App error: ', errorMsg);
    } else {
        //console.log('this is server side error');
        errorMsg = htmlMessage != '' ? `Server Error: <div>${htmlMessage}</div>` : 'Server Error';
        logger.error('Server error: ', errorMsg);
    }

    if (showmessage) {
        return await resultDialogAsync(DialogType.Error, message, 'Error', errorMsg);
    }
    return null;
};
